export default __webpack_public_path__ + "static/media/RISE_BLACK.12699e29.png";